import { preactConnectStore } from 'common/module/preact/connect-store';
import { PropertyLastContactedComponentPropsInterface } from 'common/module/property/last-contacted/component-props.interface';
import { PropertyLastContactedTemplate } from 'common/module/property/last-contacted/template';
import { PropertyLastContactedTemplatePropsInterface } from 'common/module/property/last-contacted/template-props.interface';
import { PropertyLastContactedViewStore } from 'common/module/property/last-contacted/view-store';
import { PropertyLastContactedService } from 'common/service/property-last-contacted/service';

export const PropertyLastContactedComponent = preactConnectStore<
  PropertyLastContactedViewStore,
  PropertyLastContactedTemplatePropsInterface,
  PropertyLastContactedComponentPropsInterface
>(PropertyLastContactedService, (store, { props }) => ({
  lastContacted: store.getLastContacted(props.propertyId),
  class: props.class || '',
  iconClassName: props.iconClassName,
}))(PropertyLastContactedTemplate);
